<template>
  <div class="hide-on-print">
		<!-- Page Title -->
		<page-title
			icon="ni ni-chart-bar-32"
			main="Módulo de Crédito"
			sub="Propostas"
		>
    </page-title>

		<!-- Filter -->
		<card v-if="filter">
			<div slot="header" class="row align-items-center">
				<div class="col">
					<h5 class="h3 mb-0">Pesquisar Cliente</h5>
				</div>
			</div>
			<div class="row">
				<div class="col-5">
					<label class="form-control-label">Cliente</label>
					<multiselect
            v-model="filter.client"
            :options="clients"
						placeholder="Cliente"
						label="name"
						:select-label="''"
						:deselect-label="''"
						:selected-label="'Selecionado'"
						track-by="code"
					></multiselect>
				</div>
        <div class="col-4">
					<label class="form-control-label">Ano Safra</label>
					<multiselect
            v-model="filter.anosafra"
            :options="anosafras"
						placeholder="Ano Safra"
						:select-label="''"
						:deselect-label="''"
						:selected-label="'Selecionado'"
						track-by="value"
            label="descricao"
					></multiselect>
				</div>
        <div class="col-md-3">
          <div style="margin-top: 1.8rem">
            <base-button icon @click="filterProposal" type="purple" style="width: 90%">
              <span class="btn-inner--text text-white">Pesquisar</span>
            </base-button>
          </div>
        </div>
			</div>
		</card>
    <card>
      <proposal :loadProposals="loadProposals" :createProposal="true" :clients="clients" :notEdit="false" :approval="false" :proposals="proposals"/>
    </card>
	</div>
</template>

<script>
import PageTitle from "@/layouts/PageTitle"
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import Proposal from './components/Proposal.vue'

export default {
  name: 'proposal-cri',
  components: { 
    PageTitle, 
    Proposal,
    Multiselect
  },
  data() {
    return {
      anosafras: [],
      clients: [],
      filter: {},
      proposals: [],
      loadProposals: false
    }
  },
  mounted() {
    this.getProposals()
    this.getAnosafras()
    this.getClientsCri()
  },
  methods: {
    filterProposal () {
      const client_id = this.filter.client ? this.filter.client.id : null
      const anosafra = this.filter.anosafra ? this.filter.anosafra.id : null
      this.getProposals(anosafra, client_id)
    },
    async getClientsCri () {
      const response = await this.$http.secured.get("/api/v1/credit_analysis/get_clients")
      this.clients = response.data
    },
    async getAnosafras () {
      const response = await this.$http.secured.get(`/api/v1/anosafras`)
      this.anosafras = response.data.anosafras
    },
    getProposals (anosafra_code=null, client_id=null) {
      this.loadProposals = true
      const data = {
        query: {},
        page: 1,
        per_page: 10
      }

      if (anosafra_code != null) {
        data.query.anosafra_code = anosafra_code
      }
      if (client_id != null) {
        data.query.client_id = client_id
      }

      this.$http.secured.get("/api/v1/credit_analysis/get_proposals", { params: data })
        .then((response) => {
          this.proposals = response.data
          this.proposals.map(proposal => proposal.validity_date = new Date(`${proposal.validity_date}T00:00`))
          this.loadProposals = false
        } )
        .catch((error) => console.error(error, "Something went wrong"))
    }
  }
}
</script>
